import React, { useEffect, useRef, useState } from 'react'
import { updatePageTitle } from '../../redux/active_page/actions';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';

const HomePage = () => {
	const roles: string[] = ["Full Stack Developer", "Flutter Developer", "Database Engineer", "Data Scientist"];

	const [activeRole, setActiveRole] = useState(roles[0]);
	const activeIndexRef = useRef(0);
	useEffect(() => {
		// Change the role every 1 second
		const intervalId = setInterval(() => {
			setActiveRole(roles[activeIndexRef.current]);
			activeIndexRef.current = (activeIndexRef.current + 1) % roles.length;
		}, 2000);
		return () => clearInterval(intervalId);
	}, []);

	const dispatch: Dispatch = useDispatch()
	useEffect(() => {
		dispatch(updatePageTitle("Home"));
	}, [])

	return (
		<div className="center h-center">
			<div className="main" >
				<div className="p-1">
					<p>Hello, My name is</p>
				</div>
				<h1 className="no-select">Saqib</h1>
				<div className="p-2">
					<p>I am a</p>
					<p>{activeRole}</p>
				</div>
			</div>
		</div >
	)
}

export default HomePage